import React, { useEffect, useState } from "react";
import {
  IonRadioGroup,
  IonRadio,
  IonLabel,
  IonItem,
} from "@ionic/react";

interface QuestionData {
    sentence1: string;
    sentence2: string;
    correctAnswer: string;
    options: string[]; // Type of noun: Concrete or Abstract
}


const CombineSentencesAutoSubmit: React.FC = () => {
    // Define dynamic questions with options

    const [currentIndex, setCurrentIndex] = useState(0); // Track current question
    const [feedback, setFeedback] = useState<string | null>(null); // Feedback message
    const [completed, setCompleted] = useState(false); // Track if the worksheet is completed
    const [showImage, setShowImage] = useState(false);
    const [questions, setQuestions] = useState<QuestionData[]>([]);
    const [selectedOption, setSelectedOption] = useState<string | null>(null);

    const currentQuestion = questions[currentIndex];
    
    const shuffleArray = (array: any[]) => {
        for (let i = array.length - 1; i > 0; i--) {
            const randomIndex = Math.floor(Math.random() * (i + 1));
            [array[i], array[randomIndex]] = [array[randomIndex], array[i]];
        }
        return array;
    };

    // Handle option selection and auto-submit
    const handleOptionSelect = (selectedOption: string) => {
        setSelectedOption(selectedOption);
        const currentQuestion = questions[currentIndex];
        if (selectedOption === currentQuestion.correctAnswer) {
            // Automatically move to the next question
            setShowImage(true);
            setTimeout(() => {
                const nextIndex = currentIndex + 1;
                if (nextIndex < questions.length) {
                    setCurrentIndex(nextIndex);
                    setShowImage(false);
                }
                else {
                    setCurrentIndex(0);
                    fetchQuestions();
                }
            }, 5000); // Delay reduced to 3 seconds
        }
    };

    const fetchQuestions = async () => {
        try {
            let data: QuestionData[] = [];

            if (process.env.REACT_APP_DEVELOPMENT !== 'WEB') {
                const response = await fetch(process.env.REACT_APP_API_URL + 'CombineSentences.json');
                data = await response.json();
            } else {
                const module = await import('../../../datas/CombineSentences.json');
                data = module.default;
            }

            const shuffledQuestions = shuffleArray(data);
            setQuestions(shuffledQuestions);
        } catch (error) {
            console.error('Error loading data:', error);
        }
    };

    useEffect(() => {
        fetchQuestions();
    }, []);


    return (
    <>
        {showImage === false ? (
        <>
            <div className="contentPart showCenter fillPreposition additionWord">
                <div>
                    <p>
                        <strong>Sentence 1:</strong> {questions[currentIndex]?.sentence1}
                    </p>
                    <p>
                        <strong>Sentence 2:</strong> {questions[currentIndex]?.sentence2}
                    </p>
                    <IonRadioGroup
                        onIonChange={(e) => handleOptionSelect(e.detail.value)}
                    >
                        {questions[currentIndex]?.options.map((option, index) => (
                            <IonItem key={index}
                            className={` ${
                                selectedOption === option
                                ? option === questions[currentIndex]?.correctAnswer
                                    ? "correct"
                                    : "errorItems"
                                : ""
                            }`}>
                            <IonRadio slot="start" value={option} />
                            <IonLabel>{option}</IonLabel>
                        </IonItem>
                        ))}
                    </IonRadioGroup>
                </div>
            </div>
            </>
            ) : (
            <>
                <div className="contentPart showMiddle">
                    <img
                        style={{ height: "150px" }}
                        className="img-fluid"
                        src={process.env.REACT_APP_WELDONE_LINK}
                    />
                </div>
            </>
        )}
    </>
    );
};

export default CombineSentencesAutoSubmit;
